import React, {useState, useEffect} from 'react'
import {Field} from 'formik'
import {useIntl} from 'react-intl'
import {Pricing} from '../../../pricing/core/_models'
import {getPricing} from '../../../pricing/core/_requests'

import {
  CustomSelect,
  DatePicker,
} from '@/components/form'

const now = new Date()
const initialFilters = {
  status: 'SUCCEED',
  from: new Date([
    now.getFullYear(),
    (now.getMonth() + 1).toString().padStart(2, '0'),
    '01'
  ].join('-'))
}

const statuses = [
  'SUCCEED',
  'PENDING',
  'FAILED',
]

const FilterForm = () => {
  const intl = useIntl()
  const [paymodes, setPaymodes] = useState<Array<Pricing>>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    const load = async () => {
      try {
        setPaymodes(await getPricing())
      } catch (e: unknown) {
        console.log(e)
      } finally {
        setIsLoading(false)
      }
    }
    void(isLoading && load())
  }, [isLoading])


  return (
    <>
      <Field
        component={DatePicker}
        label='From'
        name="from"
        id="from"
        required={true}
        options={{
          dateFormat: "Y-m-d",
          maxDate: now
        }}
      />

      <Field
        component={DatePicker}
        label='To'
        name="to"
        options={{
          dateFormat: "Y-m-d",
          maxDate: now
        }}
      />

      <Field
        default="Select paymode"
        component={CustomSelect}
        label="Payment mode"
        name="type"
        options={paymodes.map((p: Pricing) => {
          return { value: p.type, label: intl.formatMessage({id: `P2C.PAYMODE_${p.type.toUpperCase()}`})}
        }).concat([{
          value: 'offerwall',  label: intl.formatMessage({id: 'P2C.PAYMODE_OFFERWALL'})
        }])}
      />

      <Field
        default="Select status"
        component={CustomSelect}
        label="Status"
        name="status"
        options={statuses.map((s:string) => {
          return { value: s, label: intl.formatMessage({id: `P2C.TRX_STATUS_${s}`})}
        })}
      />

    </>
  )
}

export {FilterForm, initialFilters}
